import { isLength } from '../../../../lib/util/helpers';

/**
 * The flow is replaced wholesale once the questionnaire arrives, so everything that has to outlive
 * that moment belongs here — the customer code from the finder link, for one, which is seeded
 * before the questionnaire is loaded.
 */
export function getQuestionnairePagesFlow({ chapters, pages, allShownButtonsIds, introCustomerCode = '' }) {
  const firstPageElements = pages[0]?.elements;

  return {
    allChapters: chapters,
    allPages: pages,
    introCustomerCode,
    productPrefillBaseline: {
      allChapters: chapters,
      allPages: pages,
      answersScoring: {},
    },
    currentChapterId: chapters[0]?.id,
    currentPageId: pages[0].id,
    currentFlowElement: isLength(firstPageElements) ? firstPageElements[0] : null,
    currentElementsIds: isLength(firstPageElements) ? [firstPageElements[0]?.id] : [],
    allShownButtonsIds,
    prevPageIds: [],
    completed: false,
    answersScoring: {},
    progressPercentage: 0,
    rulesProductsProperties: [],
    rulesAnswersScore: [],
    rulesAnswersSavings: [],
    hideProducts: [],
    clickedButtonsIds: [],
    introPrefillApplied: false,
    introPrefillError: null,
    introPrefillLoading: false,
    prefillSessionVersion: 0,
  };
}
